// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.extensions.widget .extension-layout {
  overflow-y: auto;
  overflow-x: hidden;
}

.extensions.widget .extension-layout .item .content {
  padding-right: 5px;
}

.extensions.widget .extension-layout .item .content > span {
  font-size: 95%;
}

.extensions.widget .extension-layout .item .content .description {
  margin-top: 2px;
}

.extensions.widget .extension-layout .item .header {
  width: fit-content;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Home/widgets/Extensions/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".extensions.widget .extension-layout {\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.extensions.widget .extension-layout .item .content {\n  padding-right: 5px;\n}\n\n.extensions.widget .extension-layout .item .content > span {\n  font-size: 95%;\n}\n\n.extensions.widget .extension-layout .item .content .description {\n  margin-top: 2px;\n}\n\n.extensions.widget .extension-layout .item .header {\n  width: fit-content;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
